import { useEffect, useState } from 'react';
import { Space, Table, Button, Alert, Modal, Popconfirm, Tag  } from 'antd';
import { DateComponent } from '../../../components/liste/dateComponent';
import { DeleteOutlined, DislikeOutlined, EditOutlined, LikeOutlined, PlusOutlined } from '@ant-design/icons';
import { addAssertion, deleteAssertion, getListeAssertion, updateAssertion, updateEtatAssertion } from '../../../data/params/assertion';



const Assertion = () => {
  const [assertions, setAssertions] = useState([])
  const [assertion, setAssertion] = useState([])
  const [error, setError] = useState(false)
  const [message, setMessage] = useState('')
  const [libelle, setLibelle] = useState('') 
  const [description, setDescription] = useState('') 
  const [search, setSearch] = useState('') 
  const [loading, setLoading] = useState(false) 
  const [open, setOpen] = useState(false);
  const [edite, setEdite] = useState(false);

  const columns = [
    {
      title: '#',
      render: (text, record, index) => <span className='display-block chart-blue'>{ index+1 }</span>
    },
    {
      title: 'Libelle',
      dataIndex: 'libelle',
      key: 'libelle',
      render: (text) => <span className='display-block bold'>{text}</span>,
    },
    {
      title: 'Description',
      dataIndex: 'description',
      key: 'description',
    },
    {
      title: 'Etat',
      dataIndex: 'etat',
      key: 'etat',
      render: (_, record, index) =>  record.etat === 1 ? <Tag color="green">Activé</Tag> : <Tag color="red">Désactivé</Tag>
    },
    {
      title: 'Créée le / Par',
      dataIndex: 'createdAt',
      key: 'createdAt',
      render: (_, record, index) => <DateComponent date={record.createdAt} user={record.nom_user+" "+record.prenom_user} key={index} />
    },
    {
      title: 'Action',
      key: 'action',
      render: (_, record) => (
        <Space size="middle">
          <Button
            type="primary"
            icon={<EditOutlined />}
            onClick={() => selectAssertion(record.id)}
          />

          {record.etat === 0 && <Popconfirm
            title={`Activer la période ${record.libelle} ?`}
            description={`Voulez vous vraiment activer la période ${record.libelle} ?`}
            onConfirm={() => handleUpdateEtatAssertion(record.id, 1)}
            okText="Oui"
            cancelText="Non"
          >
            <Button
              icon={<DislikeOutlined />}
              className='chart-bg-orange'
              title='Activer ?'
            />
          </Popconfirm>}

          {record.etat === 1 && <Popconfirm
            title={`Désactiver la période ${record.libelle} ?`}
            description={`Voulez vous vraiment désactiver la période ${record.libelle} ?`}
            onConfirm={() => handleUpdateEtatAssertion(record.id, 0)}
            okText="Oui"
            cancelText="Non"
          >
            <Button
              icon={<LikeOutlined />}  
              className='chart-bg-green'
              title='Désactiver ?'
            />
          </Popconfirm>}

          <Popconfirm
            title={`Supprimer la période ${record.libelle} ?`}
            description={`Voulez vous vraiment supprimer la période ${record.libelle} ?`}
            onConfirm={() => handleDeleteAssertion(record.id)}
            okText="Oui"
            cancelText="Non"
          >
            <Button
              title='Supprimer ?'
              type="primary"
              icon={<DeleteOutlined />}
              danger  
            />
          </Popconfirm>
          
        </Space>
      ),
    },
  ];


  const filteredItems = assertions.filter(
    (item) =>
      item.libelle.toLowerCase().includes(search.toLowerCase()) ||
      item.description.toLowerCase().includes(search.toLowerCase()) ||
      item.id === parseInt(search)
  )

  const showModal = () => {
    setOpen(true);
  };
    
  const handleAddAssertion = async () => {
    setLoading(true);
    const data = { libelle, description }
    console.log(data)
    const { status, message } = await addAssertion(data)
    setMessage(message)
    if (status === 'success') {
      setError(false)
      setLibelle('')
      setDescription('')
      handleListeAssertion()
      setLoading(false)
    } else {
      setError(true)
      setLoading(false)
    }
  };

  const handleModifierAssertion = async () => {
    setLoading(true);
    const data = { assertion_id:assertion.id, libelle, description }
    console.log(data)
    const { status, message } = await updateAssertion(data)
    setMessage(message)
    if (status === 'success') {
        setError(false)
        setLibelle('')
        setDescription('')
        handleListeAssertion()
        setLoading(false)
    } else {
      setError(true)
      setLoading(false)
    }
  };

    const handleCancel = () => {
        setOpen(false);
        setEdite(false)
        setLibelle('')
      setDescription('')
      setError(false)
    };

  const selectAssertion = (assertion_id) => {
    const privil = assertions.filter(periode => periode.id === assertion_id)[0]
    setAssertion(privil)
    setLibelle(privil.libelle)
    setDescription(privil.description)
    setEdite(true)
    setOpen(true);
  }


  const handleListeAssertion = async () => {
    setLoading(true)
    const { result, status, message } = await getListeAssertion()
    setMessage(message)
    if (status === 'success') {
      setError(false)
      setAssertions(result)
      handleCancel()
      setLoading(false)
    } else {
      setError(true)
      setLoading(false)
    }
  }

  const handleDeleteAssertion = async (assertion_id) => {
    setLoading(true)
    const data = {assertion_id}
    const { status, message } = await deleteAssertion(data)
    setMessage(message)
    if (status === 'success') {
      setError(false)
      handleListeAssertion()
      setLoading(false)
    } else {
      setError(true)
      setLoading(false)
    }
  }


  const handleUpdateEtatAssertion = async (assertion_id, etat) => {
    setLoading(true)
    const data = {assertion_id, etat}
    const { status, message } = await updateEtatAssertion(data)
    setMessage(message)
    if (status === 'success') {
        setError(false)
        setLibelle('')
        setDescription('')
        handleListeAssertion()
        setLoading(false)
    } else {
      setError(true)
      setLoading(false)
    }
  }

  // const handleSearchDesCivilite = () => {
  //   const civs = assertions.filter(civilite => civilite.id == )

  // }

  useEffect(() => {
    handleListeAssertion()
  }, [])


  return (
    <>
      <div className="card mb-5 mb-lg-10">
        {error === true &&
          <Space
            direction="vertical"
            style={{
              width: '100%',
            }}
          >
            <Alert
              message="Error"
              description={message}
              type="error"
              showIcon
              
            />
          </Space>
        }
        
        <div className="card-header">
            
          <div className="card-title">
            <h3>Liste des assertions</h3>
          </div>
    
          <div className="card-toolbar">
            <div className="my-1 me-4">

              <input type="text" name="fname" onChange={e => setSearch(e.target.value)} class="form-control form-control-lg form-control-solid mb-3 mb-lg-0" placeholder="Rechercher" />
                
            </div>

            <Button
              type="primary"
              icon={<PlusOutlined />}
              onClick={showModal}
              size='large'
            >
              Ajouter
            </Button>
            {/* <a href="#" className="btn btn-sm btn-primary my-1">View All</a> */}
          </div>
            
        </div>
                
        <div className="card-body p-0">
            
            <div className="table-responsive">
                
              <Table loading={loading} columns={columns} dataSource={filteredItems} pagination= { {current: 1, pageSize: 50} } />
                
            </div>
            
        </div>
                
      </div>

      <Modal
        open={open}
        title={!edite ? "Enregistrer une nouvelle assertion" : "Modifier la assertion" }
        onOk={ !edite ? handleAddAssertion : handleModifierAssertion }
        onCancel={handleCancel}
        footer={[
          <Button key="back" onClick={handleCancel}>
            Annuler
          </Button>,
          <Button key="submit" type="primary" loading={loading} onClick={ !edite ? handleAddAssertion : handleModifierAssertion }>
            Enregistrer
          </Button>,
        ]}
      >
        
        {error === true && <Space
          direction="vertical"
          style={{
            width: '100%',
          }}
        >
          <Alert message={message} type="error" showIcon />

        </Space>}
        <p>
          <label className='bold'>Libelle</label>
          <input type="text" name="fname" class="form-control form-control-lg form-control-solid mb-3 mb-lg-0" onChange={e => setLibelle(e.target.value)} value={libelle} placeholder="Entrez le libelle" />
        </p>
        <p>
          <label className='bold'>Description</label>
          <input type="text" name="fname" class="form-control form-control-lg form-control-solid mb-3 mb-lg-0" onChange={e => setDescription(e.target.value)} value={description} placeholder="Entrez la description" />
        </p>
      </Modal>
    </>
  )

}

export default Assertion;